module.exports = "/images/bh.svg?69a6e4209b80a81657a008ae3573de4a";